declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_widget_float_group_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_group_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_group_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_group_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_group['ungroup'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_group extends $shm_hitalama_map_widget_float {
		set_relatives( ): any
		fit_to_widgets_auto( ): any
		count_title( ): string
		Count( ): $mol_view
		Ungroup_icon( ): $mol_icon_ungroup
		ungroup( next?: any ): any
		Ungroup( ): $mol_button_minor
		auto( ): readonly(any)[]
		tools_custom( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=group.view.tree.d.ts.map